import { Title } from "@solidjs/meta";
import { HttpStatusCode } from "@solidjs/start";
import { Show } from "solid-js";
import { isServer } from "solid-js/web";

import styles from "~/components/Post.module.scss";

interface UnknownErrorProps {
  readonly code?: number;
  readonly reset: () => void;
}

export default function UnknownError(props: UnknownErrorProps) {
  return (
    <>
      <HttpStatusCode code={props.code ?? 500} />
      <main>
        <Title>Erro interno</Title>
        <article class={styles.article}>
          <h1>Ouch! Erro interno</h1>
          <div class={styles.body}>
            <p>
              Ocorreu um erro ao carregar esta página. Geralmente, erros assim
              são temporários, e os monitoramos continuamente. Caso o erro
              persista, não hesite em entrar em contato conosco!
            </p>
            <Show when={!isServer}>
              <p>
                <button type="button" onClick={props.reset}>
                  Recarregar
                </button>
              </p>
            </Show>
          </div>
        </article>
      </main>
    </>
  );
}
